module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiI+PGRlZnM+PHBhdGggaWQ9InN2ZjZhIiBkPSJNMzU1Ljc2IDEyM3MtNi4yNjQtOC0xMS4yNjQtMi4wODZjLTUgNS45MTQgNy44NyAyNC4wOSAxMi4xOTIgMjMuMDQxIDEuOTg0LS40ODIgMTUuNDU2LTE4LjM5NiAxMC4zMDgtMjMuMDQxLTYtNS40MTQtMTEuMjM2IDIuMDg2LTExLjIzNiAyLjA4NnoiLz48L2RlZnM+PGc+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM0MyAtMTE4KSI+PHVzZSBmaWxsPSIjZmZmIiB4bGluazpocmVmPSIjc3ZmNmEiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon-heart.svg
// module id = 68
// module chunks = 0